export const apiPath = '/v2/tasks';
const actionType = 'TASKS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
